import { GraphQL } from "@graphql/graphQL";
import { DeleteApplianceListMutation, DeleteApplianceListMutationVariables } from "@models/graphql";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

const defaultDeleteApplianceListOptions: MutationHookOptions<DeleteApplianceListMutation, DeleteApplianceListMutationVariables> = {

};

export const useDeleteApplianceList = (options?: MutationHookOptions<DeleteApplianceListMutation, DeleteApplianceListMutationVariables>) => {
    const [hookState, setHookState] = useState<{
        isLoading: boolean;
        data?: DeleteApplianceListMutation;
        error?: ApolloError;
    }>({
        isLoading: false
    });

    const [mutation] = useMutation<DeleteApplianceListMutation, DeleteApplianceListMutationVariables>(GraphQL.deleteApplianceList);

    const deleteApplianceList = async (variables: DeleteApplianceListMutationVariables) => {
        setHookState({
            isLoading: true
        });

        try {
            const response = await mutation({
                ...defaultDeleteApplianceListOptions,
                ...options,
                variables
            });

            setHookState({
                data: response.data,
                isLoading: false
            });

            return {
                data: response.data,
                error: response.errors
            };
        } catch (error) {
            setHookState({
                error,
                isLoading: false
            });

            return {
                error
            };
        }
    };

    return {
        isLoading: hookState.isLoading,
        error: hookState.error,
        data: hookState.data,
        deleteApplianceList
    };
};
